var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4141 10.5832C11.6522 8.82133 8.24194 8.68776 6.24376 10.6859C6.00707 10.9226 5.22687 11.7028 5.03158 11.8981C3.02318 13.9065 2.97719 17.1168 4.92886 19.0685C6.61065 20.7503 9.22703 20.9488 11.2036 19.6864C11.5208 19.4838 11.8215 19.2435 12.0993 18.9658M10.5857 13.4117C12.3476 15.1736 15.7579 15.3071 17.7561 13.3089C17.9928 13.0722 18.773 12.292 18.9683 12.0968C20.9767 10.0883 21.0227 6.87806 19.071 4.92638C17.3892 3.24459 14.7729 3.04614 12.7963 4.30853C12.4791 4.51115 12.1783 4.75136 11.9006 5.02911",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.5b3265195b3446776b00c7f21a9e8f49.svg";
export { ForwardRef as ReactComponent };